import React from 'react';
import {connect} from 'react-redux'
import CareerPopUp from './CareerPopUp'
import {TweenMax} from 'gsap'
import ScrollToPlugin from "gsap/ScrollToPlugin";

import MultiLangText from '../multilang/MultiLangText'

class CareersPage extends React.Component {


  constructor(){
    super()
    let cols = this.getCols();


    this.state = {
      cols,
      currentCareer : null,
      popUpOpen:false,

    }

    this.openPopUp = this.openPopUp.bind(this)
    this.closePopUp = this.closePopUp.bind(this)

    this.resize = this.resize.bind(this)

  }






  openPopUp(item){
    //console.log('open',item);
    this.setState({currentCareer:item,popUpOpen:true});

    let scrollToPos =  this.refs.careersPage.getBoundingClientRect().top+window.scrollY;
        scrollToPos -= 35;

    //window.scrollTo(0,scrollTo)
    //console.log('scrollTo',scrollTo);

    TweenMax.to(window,.3,{scrollTo:{y:scrollToPos,autoKill:false}})
  }

  closePopUp(){
    this.setState({popUpOpen:false})
  }



  resize(){

    let cols = this.getCols();
    this.setState({cols})
  }

  getCols(){

    let cols = 3;

    if(window.innerWidth < 769){
      cols = 2;
    }

    if(window.innerWidth < 481){
      cols = 1;
    }

    return cols
  }

  componentDidMount(){
    window.addEventListener('resize',this.resize)
  }

  componentWillUnmount(){
    window.removeEventListener('resize',this.resize)
  }

  renderCareer(item,i,j){

    let isAvailable = item.acf.available

    //console.log("Career",item);

    //this.props.acf.title_with_breaks |
    let titleObj =  {
            en:item.title.rendered,
            de:item.acf.title_de,
            it:item.acf.title_it,
            es:item.acf.title_es,
            hu:item.acf.title_hu
          };

    if(item.acf.title_with_breaks){

      for(let i in item.acf.title_with_breaks){
        if(item.acf.title_with_breaks[i]){
            titleObj = item.acf.title_with_breaks
            //console.log("Found a title",titleObj);
        }
      }

    }



    return (<div key={'c'+i+'_'+j} className={"career "+((isAvailable)? ' available' : 'not-available')}>
                  <div className="text" >
                  <div className="location" dangerouslySetInnerHTML={{__html:item.acf.location}}></div>
                    <h5 className="title"><MultiLangText text={titleObj} /></h5>
                    <div className="learn-more-link" onClick={()=>this.openPopUp(item)}>
                    <span className="inner-text" ><MultiLangText text={this.props.optionsData.data.learn_more_careers_page} /></span>
                    </div>
                  </div>
            </div>)
  }

  calculatePopUpPosition(){

      if(document.querySelector('.career-pop-up')){
          let popupHeight = document.querySelector('.career-pop-up').getBoundingClientRect().height;

              //document.querySelector('.career-pop-up').style.marginTop = -(.getBoundingClientRect().height;)+'px';
              document.querySelector('.careers-list').style.minHeight= (popupHeight+40)+'px';
      }
  }
  componentDidUpdate(){
    this.calculatePopUpPosition();
  }

  render() {


    //console.log("Careers Page",this);

    const careers = this.props.careersData.data;


    // split the work into rows
    let rows = []


    let i,j,chunk = this.state.cols;
      for (i=0,j=careers.length; i < j; i+=chunk) {
          rows.push(careers.slice(i,i+chunk));
      }




    return (
      <div className="careers-page scroll-anchor" ref="careersPage">

        <div className="careers-list" ref="careersList">
            {
                rows.map((row,i)=>{
                  return(<div key={'r'+i} className="row">
                      {
                        row.map((item,j)=>{
                            return (this.renderCareer(item,j,i))
                        })
                      }
                  </div>)
              })
            }

        </div>

        <CareerPopUp currentCareer={this.state.currentCareer} optionsData={this.props.optionsData}  closePopUp={this.closePopUp} open={this.state.popUpOpen} />

      </div>
    );
  }

}

const mapStateToProps = (state)=>{
  let careersData = state.KastnerStore.careersData
  let optionsData = state.KastnerStore.optionsData;

  return {
      careersData,
      optionsData
    }
}

export default connect(mapStateToProps)(CareersPage);



// WEBPACK FOOTER //
// ./src/modules/pages/CareersPage.js